import GetData from '../helpers/GetData';
import Pagination from '../helpers/Pagination';

export default class BlogListing {
    constructor(root) {
        this.root = root;
        this.listing_options = JSON.parse(this.root.dataset.listingOptions);
        this.item_container = this.root.querySelector('.js-blog-listing-items');
        this.load_more_button = this.root.querySelector('.js-blog-listing-pagination');
        this.random_seed = new Date().getTime();

        this.pagination = new Pagination(this.load_more_button, 'button', () => {
            this.getPage();
        });

        this.getPage();
    }

    getPage() {
        let orderby = null;
        let tax_query = null;

        if(this.listing_options.order == 'random') {
            orderby = `rand(${this.random_seed})`;
        }

        this.data = new GetData({
            endpoint: 'get-blogs',
            loading: this.load_more_button,
            query_args: {
                paged: this.pagination.current_page,
                posts_per_page: 6,
                exclude_last_post: this.listing_options.exclude_last_post,
                orderby: orderby,
                categories: this.listing_options.categories
            },
            callback: (data) => {
                this.callback(data);
            }
        });
    }

    callback(data) {
        if(this.pagination.current_page == data.num_pages) {
            this.load_more_button.parentElement.classList.add('--hidden');
        }

        data.results.forEach((post, index) => {
            this.item_container.insertAdjacentHTML('beforeend', this.makePost(post));
        });

        this.load_more_button.classList.remove('--loading');
    }

    makePost(data) {
        return `
            <a class="block-blog-listing__blog-grid__item__link" href="${data.permalink}">
                <div class="block-blog-listing__blog-grid__item">
                    <img class="block-blog-listing__blog-grid__item__thumbnail --crop-${data.crop_location}" src="${data.thumbnail.sizes.large}" alt="${data.thumbnail.alt}"/>
                    <div class="block-blog-listing__blog-grid__item__details">
                        <p class="block-blog-listing__blog-grid__item__details__title">${data.title}</p>
                    </div>
                </div>
            </a>
        `;
    }
}
